// Offers Module
// Import all offer-related components and configuration

// Import components - these will register themselves as custom elements
import './offer-card.ts';
import './offer-card-header.ts';
import './offer-includes-badges.ts';
import './offer-what-we-do.ts';
import './offer-what-you-get.ts';
import './offer-addons-box.ts';
import './offers-container.ts';
import './course-promo.ts';

// Export configuration for external use if needed
export * from './offers-config.ts';

console.log('Offer components loaded');

